import { useTranslation } from 'next-i18next'
import styled from 'styled-components'

import { breakpoints, colors, fontSizes, fontWeights } from '@/styles'
import { Button } from '@/components/button-new'
import CloseButton from '@/components/close-button'
import { InfoCircle } from '@/components/icons'
import { createModal, useModalize } from '@/components/modalize'

const Wrapper = styled.div`
  padding: 50px 25px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Title = styled.h1`
  font-size: 23px;
  line-height: 32px;
  color: ${colors.regular};
  font-weight: ${fontWeights.medium};
  text-align: center;
  margin: 23px 0;

  @media (max-width: ${breakpoints.phoneMax}) {
    font-size: ${fontSizes.medium};
    margin: 20px 0 15px;
  }
`

const Text = styled.p`
  margin: 0 0 50px;
  font-size: ${fontSizes.regular};
  text-align: center;

  @media (max-width: ${breakpoints.phoneMax}) {
    margin: 0 0 30px;
  }
`

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  *:first-child {
    margin-right: 15px;
  }
`
interface Props {
  url: string
  message: string
}

const ExternalLinkModal: React.FC<Props> = ({ url, message }) => {
  const { t } = useTranslation()
  const { close } = useModalize()

  const onBack = () => {
    close()
  }

  const onProceed = () => {
    window.open(url, '_blank', 'noopener,noreferrer')
    close()
  }

  return (
    <Wrapper>
      <CloseButton onClick={close} />
      <InfoCircle id="info_circle" width={64} height={64} />
      <Title>
        {t(
          'b.listing.external_link_modal.title.text',
          "You're leaving liv.rent"
        )}
      </Title>
      <Text>{message}</Text>
      <ButtonRow>
        <Button theme="secondary" onClick={onBack}>
          {t('common.back', 'Back')}
        </Button>
        <Button theme="primary" onClick={onProceed}>
          {t('common.proceed', 'Proceed')}
        </Button>
      </ButtonRow>
    </Wrapper>
  )
}

export const show = createModal(ExternalLinkModal, { width: 425 })
